import { type Label } from "@doitintl/cmp-models";
import { type ModelReference } from "@doitintl/models-any";

import { type DataColumn } from "../../../types/FilterTable";
import { type LabelWithRef } from "./types";

export const updateColumnFiltersWithLabels = (
  labels: LabelWithRef[] | undefined,
  existingColumns: readonly DataColumn[] = [],
  insertPosition: number = existingColumns.length
): DataColumn[] => {
  const labelColumn: DataColumn = {
    label: "Label",
    path: "data.labels",
    toOption: (labelRefs: ModelReference<Label>[]) => {
      if (!labelRefs) {
        return [];
      }

      return labelRefs.reduce(
        (arr, labelRef) => {
          const label = labels?.find((l) => l.ref.id === labelRef.id);
          if (label) {
            arr.push({
              value: labelRef.id,
              label: label.data.name,
            });
          }

          return arr;
        },
        [] as { value: string; label: string }[]
      );
    },
    transformData: (data: ModelReference<Label>[] | undefined) => (data ? data.map((d) => d.id) : []),
  };

  const updatedColumns = [...existingColumns];
  updatedColumns.splice(insertPosition, 0, labelColumn);
  return updatedColumns;
};
